/** The nomenclature code seeded by V059. Renaming it here without renaming the seed empties
 * every picker — both the event wizard's theme field and the public calendar's theme filter. */
export const EVENT_THEMES = 'EVENIMENTE_TEMATICA';
